import { UserSettings } from '../types/UserSettings';

export const isUserSettings = (arg: any): arg is UserSettings => !!arg
  && arg.currentLocale !== undefined
  && arg.currentCountry !== undefined
  && arg.currentRegion !== undefined;
